import React__default from 'react';
import PropTypes from 'prop-types';

function LoadingBlock(props) {
  var width = props.width,
    height = props.height,
    className = props.className;
  var loadingBlockStyles = {
    width: width,
    height: height
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "bf-loading-block ".concat(className),
    style: loadingBlockStyles
  });
}
LoadingBlock.defaultProps = {
  width: '100%',
  height: '20px',
  className: ''
};
LoadingBlock.propTypes = {
  /**
  LoadingBlock width
   */
  width: PropTypes.string,
  /**
  LoadingBlock height
   */
  height: PropTypes.string,
  /**
  LoadingBlock custom className
   */
  className: PropTypes.string
};

export default LoadingBlock;
//# sourceMappingURL=LoadingBlock.js.map
